import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import Header from '../Header';
import { Helmet } from 'react-helmet';
import Panel from '../../elements/Panel';
import PropTypes from 'prop-types';
import React from 'react';
import { pure } from 'recompose';
import Footer from "../Footer";

const messages = defineMessages({
  htmlHeader: {
    id: 'not-found.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Create Engagement'
  },
  headerTitle: {
    id: 'not-found.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Page Not Found'
  },
  headerSubTitle: {
    id: 'not-found.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'The page "{pageUrl}" does not exist'
  }
});

const NotFound = ({ intl, locale, location }) => (
  <div className="not-found page">
    <Helmet>
      <title>{intl.formatMessage(messages.htmlHeader)} - Shift</title>
    </Helmet>
    <Header
      title={intl.formatMessage(messages.headerTitle)}
      subtitle={intl.formatMessage(messages.headerSubTitle, {
        pageUrl: location.pathname
      })}
      icon="engagement"
      locale={locale}
    />
    <div className="main">
      <div className="panels">
        <Panel
          header={
            <h3>
              <FormattedMessage
                id="not-found.panel.title"
                defaultMessage="Page Not Found"
              />
            </h3>
          }
        >
          <p>
            <FormattedMessage
              id="not-found.panel.paragraph.1"
              defaultMessage={
                'The page you have specified "{pageUrl}" does not exist. Please check the URL to see if it is correct.'
              }
              values={{
                pageUrl: location.pathname
              }}
            />
          </p>
        </Panel>
      </div>
    </div>
    <Footer />
  </div>
);

NotFound.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object,
  location: PropTypes.object
};

export default pure(injectIntl(NotFound));



// WEBPACK FOOTER //
// ./src/components/views/NotFound/index.js